export const generateUniqueId = (): string => {
    return Math.random().toString(36).substring(2, 16);
}
